export default ({ request }) => ({

  prjCategoryListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/category/list',
      method: 'post',
      data
    })
  },
  prjCategoryDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/project/category/detail',
      method: 'post',
      data
    })
},
  prjCategorySaveApi (data = {}) {
    return request({
      url: '/digitalCenter/project/category/save',
      method: 'post',
      data
    })
  },
  prjCategoryDelApi (data = {}) {
    return request({
      url: '/digitalCenter/project/category/del',
      method: 'post',
      data
    })
  }
})